import { ThreeView } from "../View3dWebCad";
import { WallItemOverControls } from '../controls/WallItemOverControls';
import { defines } from "../../base";
import { itemLoader } from "./itemLoader";
import { ObjectType } from "../ObjectType";

export class AddWallItemLoader extends itemLoader {

    private controller: WallItemOverControls;

    constructor(itemId: string, index: string) {
        super(itemId, index);
    }

    protected createController(object: THREE.Object3D) {
        const camera = ThreeView.get().wcCameras.getCamera(defines.CameraDefs.wlkthCamNo);
        const element = ThreeView.get().wcRenderer.me.domElement;
        this.controller = new WallItemOverControls([object], camera.me, element);
    }

    protected removeController() {
        this.controller.dispose();
        this.controller = undefined;
    }

    protected createMeasure(object: THREE.Object3D) {
        //メジャーの作成
        ThreeView.get().ItemDragManager.selectObj = object;
        ThreeView.get().measuremanager.createMeasure(object);
    }

    protected removeMeasure() {
        //メジャーの削除
        ThreeView.get().ItemDragManager.selectObj = undefined;
        ThreeView.get().measuremanager.removeMeasure();
    }

    protected location(e): boolean {
        const hitObj = ThreeView.get().selectManager.hitObjects(e);

        if (hitObj.length < 1) return;

        return (ObjectType.isWall(hitObj[0].object) || ObjectType.isKosiWall(hitObj[0].object));
    }
}
